<template>
  <div class="page">
    <!-- 遮罩 -->
    <div class="mask"></div>

    <!-- 弹窗 -->
    <div class="popup" :style="{ marginTop: `${popup_top}px` }">
      <!-- 弹窗内容 -->
      <div class="popup-content">
        <!-- 背景 -->
        <div class="content-bg">
          <img src="@/assets/images/YuliApp/memory/pic_bg.png" />
        </div>

        <!-- 图片 -->
        <div class="content-pic">
          <img
            :src="
              img_url
                ? img_url
                : require(`@/assets/images/YuliApp/memory/pic_temp.png`)
            "
          />
        </div>

        <!-- 等级 -->
        <div class="content-icon">
          <img
            :src="
              require(`@/assets/images/YuliApp/memory/icon_${type || 'a'}.png`)
            "
          />
        </div>

        <!-- 文字内容 -->
        <div class="content-text">
          <div class="pos content-text-head">Memory of</div>
          <div class="pos content-text-name">{{ memory_name }}</div>

          <div class="pos content-text-body">
            <span class="content-text-body-name">{{ memory_symbol }}: </span
            >{{ memory_content }}
          </div>

          <div v-if="memory_name" class="content-text-footer">
            - {{ memory_name }}
          </div>
        </div>
      </div>

      <!-- 弹窗按钮 -->
      <div class="popup-btn" @click="handleClose">
        <img src="@/assets/images/YuliApp/memory/icon_del.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import hookStoreState from "@/utils/useState.js";

const def = [
  {
    transform_effect: "s",
    name: "Dora",
    desc: "This about her story in the palce.his about her story in the palce.his about her story in the",
    role_property: "",
    image_url: "",
    cover_url: "",
  },
];

export default {
  props: {
    detail: {
      type: Object,
      default: null,
    },
  },
  setup(props, ctx) {
    const type = ref("a");
    const img_url = ref("");
    const memory_name = ref("");
    const memory_content = ref("");
    const memory_symbol = ref("");

    const storeStateObj = hookStoreState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
    });
    const { statusBarHeight } = storeStateObj;
    const popup_top = ref(statusBarHeight.value + window.innerHeight * 0.1);

    /**
     * 加载数据
     */
    const initData = (data) => {
      if (!data) {
        return;
      }

      const { transform_effect, name, desc, cover_url, symbol } = data;
      type.value = transform_effect || "a";
      img_url.value = cover_url || "";
      memory_name.value = name || "";
      memory_content.value = desc || "";
      memory_symbol.value = symbol || "";
    };

    /**
     * 监听传参变化
     */
    watch(
      () => props.detail,
      (value) => {
        initData(value);
      },
      {
        deep: true,
        immediate: true,
      }
    );

    /**
     * 处理关闭
     */
    const handleClose = () => {
      ctx.emit("close");
    };

    return {
      popup_top,
      type,
      img_url,
      memory_name,
      memory_content,
      handleClose,
      memory_symbol,
    };
  },
};
</script>

<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  margin-top: -60px;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
  }

  .popup {
    width: 351px;
    margin-top: 133px; // 89
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }

    &-content {
      width: 100%;

      .content {
        &-bg {
          width: 351px;
          height: 478px;
        }

        &-pic {
          width: 289px;
          height: 213px;
          position: absolute;
          top: 11px;
          left: 0;
        }

        &-icon {
          width: 80px;
          height: 80px;
          position: absolute;
          top: 8px;
          left: 37px;
        }

        &-text {
          width: 290px;
          height: 266px;
          color: #463b34;
          font-weight: 400;
          font-family: "Bad Scri0px";
          line-height: 30px;
          text-align: center;
          position: absolute;
          bottom: 116px;
          left: 0;
          right: 0;
          margin: 0 auto;

          .pos {
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
          }

          &-head {
            top: 27.07px;
            font-size: 16px;
          }

          &-name {
            top: 62.07px;
            font-size: 26px;
          }

          &-body {
            top: 104.07px;
            width: 250px;
            height: 88px;
            font-size: 20px;
            text-align: left;
            line-height: 26px;
            overflow: scroll;
            &-name {
              font-weight: 700;
            }
          }

          &-footer {
            position: absolute;
            right: 22px;
            bottom: 32px;
            font-size: 20px;
          }
        }
      }
    }

    &-btn {
      margin-top: 43px;
      width: 40px;
      height: 40px;
    }
  }
}
</style>
